// extracted by mini-css-extract-plugin
export default {"video_background":"BackgroundScreen_video_background__Emwyx","video_overlay":"BackgroundScreen_video_overlay__8Yetm"};